module.exports = __webpack_public_path__ + "static/img/call-pass.cccba503.png";